import React from "react";

import Header from "./Header";
import { useNavigate } from "react-router-dom";

import axios from "axios";

import config from "../../config";

import Footer from "./Footer";
import * as XLSX from "xlsx";
import html2pdf from "html2pdf.js";
import ReactLoading from "react-loading";

const Invoices_list = () => {
  let userDetail = localStorage.getItem("ship_rocket_user");
  console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail);
  }
  const [statecompany, setcompanyState] = React.useState();
  const [isLoading, setisLoading] = React.useState(true);
  const [isLoadingprint, setisLoadingprint] = React.useState(false);

  const [stateshipments, setShipments] = React.useState([]);
  const [state, setState] = React.useState([]);
  const [selected, setSelected] = React.useState({
    select_count: 0,
    select_order_id: [],
  });
  console.log("selected == ", selected);
  const [statecustomer, setStatecustomer] = React.useState();
  React.useEffect(() => {
    invoice_list();
    shipment_list();
  }, []);

  const shipment_list = () => {
    let dataToSend = { customer_id: userData.customer_id };

    console.log("datatoSend", dataToSend);
    let url = config.apiUrl + "/shipment/invoice_details";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        console.log("responseJson => ", res);
        if (res.data.status == true) {
          setcompanyState(res.data.output);
          setStatecustomer(res.data.customer);
        }
      })
      .catch((error) => {
        //Hide Loader
        //   setLoadingstate({...loadingstate,loading:false})
        console.log(error);
      });
  };
  const invoice_list = (status, index = 0, onLoad) => {
    let dataToSend = {};
    let url = config.apiUrl + "/shipment/customer_invoices";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);

        setState(res.data.output);
        setisLoading(false);
      })
      .catch((error) => {
        //Hide Loader
        //   setLoadingstate({...loadingstate,loading:false})
        // console.log(error);
      });
  };

  const next_step = (sub) => {
    const url = `/invoice_vendor?invoice_id=${sub.invoice_id}&invoice_date=${sub.invoice_date}&amount=${sub.amount}&invoice_period=${sub.invoice_period}&cod_verification_amount=${sub.cod_verification_amount}&delivery_update_amount=${sub.delivery_update_amount}&item_total=${sub.item_total}`;

    // Open the URL in a new tab
    window.open(url, "_blank");
  };

  const calculateDueDate = (invoiceDate, days) => {
    const date = new Date(invoiceDate);
    date.setDate(date.getDate() + days);
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const getInvoicePeriod = (invoicePeriod) => {
    const [monthName, year] = invoicePeriod.split(",");
    const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();
    const startDate = new Date(year, monthIndex, 1);
    const endDate = new Date(year, monthIndex + 1, 0);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    return `${formatDate(startDate)} to ${formatDate(endDate)}`;
  };

  const generateCombinedHTML = (sub, statecompany, statecustomer) => {
    const remainingAmount = sub.amount / 1.18; // Example calculation for remaining amount
    const gstAmount = sub.amount - remainingAmount;
    return `
    <div class="container wrap" >
      <div class="card mb-1">
        <div class="card-body">
          <div class="pb-5">
            <img src="../../../assets/img/logo.png" class="img-fluid" style="height:50px;"/>
          </div>
          <div class="row">
            <div class="col-7">
              <div class="pb-4">
                <strong>${
                  statecompany.company_name ? statecompany.company_name : ""
                }</strong><br/>
                ${
                  statecompany.company_address
                    ? statecompany.company_address
                    : ""
                }<br/>
                Phone: ${statecompany.phone ? statecompany.phone : ""}<br/>
                Email: ${statecompany.email ? statecompany.email : ""}
              </div>
              <div>
                <strong>PAN Number:</strong> ${
                  statecompany.invoice_pan ? statecompany.invoice_pan : ""
                }<br/>
                <strong>CIN Number:</strong> ${
                  statecompany.invoice_cin ? statecompany.invoice_cin : ""
                }<br/>
                <strong>GSTIN:</strong> ${
                  statecompany.invoice_gst ? statecompany.invoice_gst : ""
                }<br/>
                <strong>IRN:</strong> ${
                  statecompany.invoice_irn ? statecompany.invoice_irn : ""
                }
              </div>
            </div>
            <div class="col-5">
              <h6 class="pb-3"><strong>TAX INVOICE</strong></h6>
              <h2 class="text-success">PAID</h2>
              <div class="download_btn">
                <a href="javascript:window.print();">Download Invoice</a>
              </div>
              <div class="pt-2">
                <strong>Invoice No. :</strong> ${sub.invoice_id}<br/>
                <strong>Invoice Date :</strong> ${sub.invoice_date}<br/>
                <strong>Due Date :</strong> ${calculateDueDate(
                  sub.invoice_date,
                  15
                )}<br/>
                <strong>Invoice Period : </strong> ${getInvoicePeriod(
                  sub.invoice_period
                )}
              </div>
            </div>
          </div>
          <hr/>
          <div class="row">
            <div class="col-7">
              <strong>Invoice To:</strong>
              ${
                statecustomer.company_name
                  ? statecustomer.company_name
                  : statecustomer.full_name
                  ? statecustomer.full_name
                  : ""
              } <br/>
              ${statecustomer.address ? statecustomer.address : ""} <br/>
              ${statecustomer.city ? statecustomer.city : ""}
            </div>
            <div class="col-5">
              <strong>GSTIN:</strong> ${
                statecustomer.gst_number ? statecustomer.gst_number : ""
              } <br/>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-1">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>SAC No.</th>
                  <th>Description</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>996812</td>
                  <td>Skyship V2 Freight*</td>
                  <td>${remainingAmount.toFixed(2)}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>18.00% IGST</td>
                  <td>${gstAmount.toFixed(2)}</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="fw-bold">Grand Total Value</td>
                  <td>${sub.amount}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="card mb-1">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Transaction Date</th>
                  <th>Gateway</th>
                  <th>Transaction ID</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>${sub.invoice_date}</td>
                  <td>Wallet</td>
                  <td>NA</td>
                  <td>${sub.amount}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td class="fw-bold">Amount Due</td>
                  <td>0.00</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="card mb-1">
        <div class="card-body">
          <div class="border-bottom py-2">
            <strong>Bank and Other Commercial Details</strong>
          </div>
          <div>
            All Payments by transfer/check/DD should be draw in favour of <br/>
            <strong>Entity Name:</strong> ${
              statecompany.entity_name ? statecompany.entity_name : ""
            } <br/>
            <strong>Account number:</strong> ${
              statecompany.account_number ? statecompany.account_number : ""
            } <br/>
            <strong>Bank:</strong> ${
              statecompany.bank ? statecompany.bank : ""
            } <br/>
            <strong>Branch:</strong> ${
              statecompany.branch ? statecompany.branch : ""
            } <br/>
            <strong>RTGS/NEFT/IFSC Code:</strong> ${
              statecompany.ifsc_code ? statecompany.ifsc_code : ""
            }
          </div>
        </div>
      </div>
    </div>
  `;
  };

  // const handleBulkPrint = () => {
  //   setisLoadingprint(true);

  //   const combinedHTML = generateCombinedHTML(state);
  //   const tempContainer = document.createElement("div");
  //   tempContainer.innerHTML = combinedHTML;

  //   html2pdf()
  //     .from(tempContainer)
  //     .set({
  //       margin: 2,
  //       filename: "Bulk_invoices.pdf",
  //       image: { type: "jpeg", quality: 0.98 },
  //       html2canvas: { scale: 2 },
  //       jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //     })
  //     .save()
  //     .then(() => {
  //       setisLoadingprint(false); // Reset loading state after the process ends
  //     })
  //     .catch((error) => {
  //       console.error("PDF generation failed:", error);
  //       setisLoadingprint(false); // Reset loading state even if an error occurs
  //     });
  // };

  const handleBulkPrint = async () => {
    setisLoadingprint(true); // Show loader

    // Delay execution slightly to allow React to update the state and show the loader
    setTimeout(async () => {
      try {
        const pdfPromises = selected.select_order_id.map((invoice) =>
          generateInvoicePDF(invoice, statecompany, statecustomer)
        );

        await Promise.all(pdfPromises); // Wait for all PDFs to be generated
        console.log("All PDFs have been generated and downloaded.");
      } catch (error) {
        console.error("Error generating PDFs:", error);
      } finally {
        setisLoadingprint(false); // Hide loader after processing
      }
    }, 100); // Small delay to allow UI update
  };

  const generateInvoicePDF = (invoice, statecompany, statecustomer) => {
    // Generate the HTML for the invoice
    const invoiceHTML = generateCombinedHTML(
      invoice,
      statecompany,
      statecustomer
    );

    // Create a temporary container to hold the HTML
    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = invoiceHTML;

    // Convert the HTML to PDF
    html2pdf()
      .from(tempContainer)
      .set({
        margin: 10,
        filename: `invoice_${invoice.invoice_id}.pdf`, // Unique filename for each invoice
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      })
      .save();
  };

  const get_shipments = (invoice_id) => {
    let dataToSend = {
      invoice_id: invoice_id,
    };
    let url = config.apiUrl + "/shipment/get_invoice_shipments";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        setShipments(res.data.output);
        downloadExcel(res.data.output);
      })
      .catch((error) => {});
  };
  const transformDataForExcel = (data) => {
    return data.map((item) => {
      console.log("created == ", item.created);
      const formattedDate = item.created
        ? new Date(item.created * 1000).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })
        : "";

      const formattedTime = item.created
        ? new Date(item.created * 1000).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: true,
          })
        : "";
      return {
        "Tracking Id": item?.carrier_tracking_number || "",
        "Reference Number": item?.order_number || "",
        Carrier: item?.carrier_name || "",
        Mode: item?.product_type_name || "",
        "Carrier Product": item?.service_provider || "",
        "Current Status": getStatusText(item?.status) || "",
      };
    });
  };

  const getStatusText = (status) => {
    // Define your status mappings here
    const statusMappings = {
      0: "Pending",
      10: "RTO",
      1: "Pick Up Awaited",
      2: "Picked Up",
      3: "In Transit",
      4: "Out For Delivery",
      5: "Delivered",
      6: "Cancelled",
      7: "Failed",
      8: "NDR",
      9: "Pickup Scheduled",
      15: "Booked",
    };

    return statusMappings[status] || "";
  };

  const downloadExcel = (items) => {
    const data = transformDataForExcel(items);
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Invoice AWb");
    XLSX.writeFile(wb, "Invoice AWb.xlsx");
  };

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;

    const selectedData = isChecked ? state.map((invoice) => invoice) : [];

    setSelected({
      select_count: selectedData.length,
      select_order_id: selectedData,
    });
  };

  const handleChangeSelected = (e, sub) => {
    setSelected((prevSelected) => {
      const isAlreadySelected = prevSelected.select_order_id.some(
        (item) => item.invoice_id === sub.invoice_id
      );

      if (isAlreadySelected) {
        // Remove the selected invoice
        const updatedSelection = prevSelected.select_order_id.filter(
          (item) => item.invoice_id !== sub.invoice_id
        );
        return {
          select_count: updatedSelection.length,
          select_order_id: updatedSelection,
        };
      } else {
        // Add the selected invoice
        return {
          select_count: prevSelected.select_count + 1,
          select_order_id: [...prevSelected.select_order_id, sub],
        };
      }
    });
  };
  return (
    <div>
      {/* <?php $bodyClass = 'pg-legacy'; ?>
<?php  include('head_meta.php');  ?>
<?php  include('header.php');  ?> */}
      <Header>
        <div className="content">
          <div class="mob_nav">
            <div class="row">
              <div class="col-7">
                <div class=" d-flex justify-content-start ">
                  <a href="javascript:window.history.back();" class="">
                    <i class="bi bi-arrow-left"></i>
                  </a>
                  <h2>Invoices</h2>
                </div>
              </div>
              <div class="col"></div>
            </div>
          </div>

          <div class="row justify-content-between desk_nav">
            <div class="col-12 col-md-4 ">
              <div class="d-flex">
                <a href="javascript:window.history.back();" class="back_btn">
                  <i class="bi bi-arrow-90deg-left"></i>
                </a>
                <h2>Invoices</h2>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <div class="row justify-content-end">
                <div class="col-6 col-md-6"></div>
              </div>
            </div>
          </div>

          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginLeft: "60px",
                alignItems: "center",
                marginTop: "-200px",
                height: "100vh",
              }}
            >
              <ReactLoading
                type={"spin"}
                color={"#0d6efd"}
                height={40}
                width={60}
              />
            </div>
          ) : (
            <div class="card data_table mb-3 mb_display_none">
              <div class="card-body">
                <div class="table-responsive">
                  <div class="shipm_tablew rounded-3">
                    <table class="table align-top table-striped table-hover m-0 table-xl ">
                      <thead>
                        <tr>
                          {/* <th><input class="form-check-input form-check-input-lg" type="checkbox" id="inlineCheckbox1" value="option1" onChange={handleSelectAll} 
    checked={selected.select_order_id.length === state.length && state.length > 0}/></th> */}
                          <th width="170px">Invoice No. #</th>
                          <th width="200px">Customer</th>
                          <th>Invoice Date</th>
                          <th>Invoice Period</th>
                          <th>Invoice Amount</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {state.map((sub) => (
                          <tr class="">
                            {/* <td><input class="form-check-input form-check-input-lg" type="checkbox" checked={selected.select_order_id.some(item => item.invoice_id === sub.invoice_id)} 
    onChange={(e) => handleChangeSelected(e, sub)}/></td> */}
                            <td>
                              <h6>
                                <a href="#" class="text-primary">
                                  {sub.invoice_id}
                                </a>
                              </h6>
                            </td>
                            <td>
                              {sub.company_name
                                ? sub.company_name
                                : sub.full_name
                                ? sub.full_name
                                : ""}
                            </td>
                            <td>{sub.invoice_date}</td>
                            <td>{sub.invoice_period}</td>
                            <td>₹{sub.amount ? sub.amount : 0}</td>
                            <td>
                              <a
                                type="button"
                                class="btn btn-outline-secondary me-2"
                                onClick={() => next_step(sub)}
                                target="_blank"
                              >
                                Print Invoice
                              </a>
                              <a
                                type="button"
                                class="btn btn-outline-secondary"
                                onClick={(e) => get_shipments(sub.invoice_id)}
                              >
                                Download Shipments Report
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* <!-- Mobile View Order Data --> */}
          <section class="desk_display_none">
            {state.map((sub) => (
              <div class="card  mb-3">
                <div class="card-body">
                  <div class="row">
                    <div class="col-6 mb-2">
                      <h5>{sub.invoice_id}</h5>
                      <small>Invoice No. #</small>
                    </div>
                    <div class="col-6 mb-2">
                      <h5>Invoice Amount</h5>₹{sub.amount ? sub.amount : 0}
                    </div>
                    <div class="col-12 mb-2">
                      <h5>Customer</h5>
                      {sub.company_name
                        ? sub.company_name
                        : sub.full_name
                        ? sub.full_name
                        : ""}
                    </div>
                    <div class="col-6 mb-2">
                      <h5>Invoice Date</h5>
                      {sub.invoice_date}
                    </div>
                    <div class="col-6 mb-2">
                      <h5>Invoice Period</h5>
                      {sub.invoice_period}
                    </div>
                    <div class="col-6">
                      <div class="d-grid">
                        <a
                          class="btn btn-primary btn-block"
                          onClick={() => next_step(sub)}
                          target="_blank"
                        >
                          Print Invoice
                        </a>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="d-grid">
                        <a
                          onClick={(e) => get_shipments(sub.invoice_id)}
                          class="btn btn-danger btn-block"
                        >
                          Download Shipments
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </section>
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Invoices_list;
